<template>
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.9894 8.7824C13.9894 8.7824 9.24127 7.98955 6.20334 10.0998C4.0258 7.709 1.7739 4.4278 0 0C0 0 0.318665 3.3056 1.55083 6.01351C0.732929 8.42867 2.07132 12.9297 2.07132 12.9297L0 15.9913L2.96358 14.1006C6.45827 16.7598 10.4734 15.1375 10.4734 15.1375C13.5645 16.3206 14 15.9425 14 15.9425C14 15.9425 10.9833 14.8203 7.46737 11.4171C10.8558 9.72163 13.9894 8.7824 13.9894 8.7824ZM2.19879 7.22109C2.19879 7.22109 3.1654 9.13614 4.80121 11.0878C3.74962 11.844 2.93171 12.4417 2.93171 12.4417C1.94385 10.173 2.19879 7.22109 2.19879 7.22109ZM9.19879 14.6129C7.86039 14.9057 4.97117 15.3082 3.62215 13.6127C4.33384 13.1126 5.08801 12.6613 5.85281 12.2344C6.81942 13.198 7.94537 14.0762 9.19879 14.6129Z"
      fill="white"
    />
    <path
      d="M6.60886 5.85523C7.76511 5.5996 8.52194 4.31624 8.29928 2.98876C8.07663 1.66129 6.95881 0.792384 5.80256 1.04801C4.64631 1.30364 3.88948 2.587 4.11214 3.91447C4.33479 5.24195 5.45261 6.11085 6.60886 5.85523Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'ClientGateSvg'
}
</script>

<style></style>
